import { FormControlLabel, List } from '@mui/material'
import cn from 'classnames'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import CollectionSelector from '../../collectionselector/CollectionSelector'
import SelectionField from '../../searchitems/searchfilters/SelectionField'
import { Accordion, AccordionItem, Switch } from '@nextui-org/react'

const DropSearchFilters = ({
    setVars,
    searchDropId,
    searchAuthor,
    orderBy,
    minPrice,
    maxPrice,
    searchVerified,
    market,
    isLoading,
    upcoming,
    pfponly,
    displayCollectionSelector,
    currency,
    currencies,
}) => {
    const { t } = useTranslation('common')
    const [show, setShow] = useState(true)

    const initToggleItems = () => {
        const map = new Map()
        map.set(t('navigation.collections'), true)
        map.set(t('search.market'), market !== undefined)
        map.set(t('search.currency'), currency !== 'all')
        return map
    }

    const [toggleItem, setToggleItem] = useState(initToggleItems())

    const onSelectAuthor = (e) => {
        setVars(
            searchDropId,
            e,
            orderBy,
            minPrice,
            maxPrice,
            searchVerified,
            market,
            upcoming,
            currency,
            0,
        )
    }

    const onCheckUpcoming = (e) => {
        setVars(
            searchDropId,
            searchAuthor,
            orderBy,
            minPrice,
            maxPrice,
            searchVerified,
            market,
            e.target.checked,
            pfponly,
            currency,
            0,
        )
    }

    const onCheckPFPs = (e) => {
        setVars(
            searchDropId,
            searchAuthor,
            orderBy,
            minPrice,
            maxPrice,
            searchVerified,
            market,
            upcoming,
            e.target.checked,
            currency,
            0,
        )
    }

    const onCheckVerified = (e) => {
        setVars(
            searchDropId,
            searchAuthor,
            orderBy,
            minPrice,
            maxPrice,
            e,
            market,
            upcoming,
            currency,
            0,
        )
    }

    const onSelectMarket = (e) => {
        setVars(
            searchDropId,
            searchAuthor,
            orderBy,
            minPrice,
            maxPrice,
            searchVerified,
            e.value,
            upcoming,
            pfponly,
            currency,
            0,
        )
    }

    const onSelectCurrency = (e) => {
        setVars(
            searchDropId,
            searchAuthor,
            orderBy,
            minPrice,
            maxPrice,
            searchVerified,
            market,
            upcoming,
            pfponly,
            e.value,
            0,
        )
    }

    const dropMarketDropdownOptions = [
        { value: 'all', label: 'All' },
        { value: 'atomicdropsx', label: 'AtomicHub' },
        { value: 'neftyblocksd', label: 'NeftyBlocks' },
        { value: 'nfthivedrops', label: 'NFTHive' },
    ]

    const getMarketOption = (market) => {
        const option = Math.max(
            dropMarketDropdownOptions.map((item) => item.value).indexOf(market),
            0,
        )

        return dropMarketDropdownOptions[option]
    }

    const defaultMarketOption = getMarketOption(market)

    const dropCurrencyDropdownOptions = [{ value: 'all', label: 'All' }]

    if (currencies) {
        for (const curr of currencies) {
            dropCurrencyDropdownOptions.push({
                value: curr['symbol'],
                label: curr['symbol'],
            })
        }
    }

    const getCurrencyOption = (curr) => {
        const option = Math.max(
            dropCurrencyDropdownOptions
                .map((item) => item.value.toLowerCase())
                .indexOf(curr.toLowerCase()),
            0,
        )

        return dropCurrencyDropdownOptions[option]
    }

    const defaultCurrencyOption = getCurrencyOption(currency)

    return (
        <>
            <div
            /*       className={cn(
    {
        'w-full dark:!bg-[#121212] bg-zinc-200 rounded-xl md:w-3/10 lg:w-1/5 2xl:w-1/6 h-full hidden md:block':
            show,
    },
    { 'block md:hidden': !show },
)} */
            >
                <div className={cn('mt-6')}>
                    <div
                        className={cn('flex justify-center overflow-x-hidden')}
                    >
                        <FormControlLabel
                            control={
                                <Switch
                                    className="font-semibold"
                                    checked={upcoming}
                                    onChange={onCheckUpcoming}
                                >
                                    {t('landing.upcoming_drops')}
                                </Switch>
                            }
                            /*      labelPlacement="top" */
                        />
                    </div>
                </div>
                <div className={cn('mt-6')}>
                    <div
                        className={cn('flex justify-center overflow-x-hidden')}
                    >
                        <FormControlLabel
                            control={
                                <Switch
                                    className="font-semibold"
                                    checked={pfponly}
                                    onChange={onCheckPFPs}
                                >
                                    PFP Drops
                                </Switch>
                            }
                            /*      labelPlacement="top" */
                        />
                    </div>
                </div>
                <List>
                    {/*    <Tooltip arrow placement="right" title="Hide Filters">
                        <ListItemButton onClick={toggleShow}>
                            <ListItemText>
                                <div className="font-bold">Filters</div>
                            </ListItemText>
                            <ListItemIcon>
                                <FilterListOffIcon />
                            </ListItemIcon>
                        </ListItemButton>
                    </Tooltip> */}
                    {displayCollectionSelector === undefined ||
                    displayCollectionSelector ? (
                        <Accordion>
                            <AccordionItem
                                title={t('navigation.collections')}
                                toggleItem={toggleItem}
                                setToggleItem={setToggleItem}
                                classNames={{
                                    title: 'dark:dark:text-white !text-base !md:text-xs !xl:text-base font-semibold',
                                }}
                            >
                                <CollectionSelector
                                    searchCollection={searchAuthor}
                                    searchVerified={searchVerified}
                                    selectCollection={onSelectAuthor}
                                    onCheckVerified={onCheckVerified}
                                    searchItem={true}
                                    market={market}
                                    searchType={'drops'}
                                />
                            </AccordionItem>
                        </Accordion>
                    ) : (
                        ''
                    )}
                    <Accordion>
                        <AccordionItem
                            title={t('search.market')}
                            toggleItem={toggleItem}
                            setToggleItem={setToggleItem}
                            classNames={{
                                title: 'dark:dark:text-white !text-base !md:text-xs !xl:text-base font-semibold',
                            }}
                        >
                            <SelectionField
                                options={dropMarketDropdownOptions}
                                onChange={onSelectMarket}
                                value={defaultMarketOption}
                                placeholder={t('search.market')}
                                id="DropdownField15"
                                disabled={isLoading ? 'disabled' : ''}
                            />
                        </AccordionItem>
                    </Accordion>
                    <Accordion>
                        <AccordionItem
                            title={t('search.currency')}
                            toggleItem={toggleItem}
                            setToggleItem={setToggleItem}
                            classNames={{
                                title: 'dark:dark:text-white !text-base !md:text-xs !xl:text-base font-semibold',
                            }}
                        >
                            <SelectionField
                                options={dropCurrencyDropdownOptions}
                                onChange={onSelectCurrency}
                                value={defaultCurrencyOption}
                                placeholder={t('search.currency')}
                                id="DropdownField16"
                                disabled={isLoading ? 'disabled' : ''}
                            />
                        </AccordionItem>
                    </Accordion>
                </List>
            </div>
            <div
                className={cn(
                    { 'block md:hidden': show },
                    { 'hidden md:block': !show },
                )}
            >
                {/*       <Tooltip title={'Show filter options'}>
                    <FilterListIcon
                        className={cn('mt-4 ml-2 cursor-pointer')}
                        onClick={toggleShow}
                    >
                        <img src={'/filters.svg'} alt={'Show filter options'} />
                    </FilterListIcon>
                </Tooltip> */}
            </div>
        </>
    )
}

export default DropSearchFilters
